'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_Lsamples_Sealed$package$$anon$6$$anon$17$$anon$19(evaluator$16) {
  this.LU = null;
  this.LU = evaluator$16;
}
export { $c_Lsamples_Sealed$package$$anon$6$$anon$17$$anon$19 as $c_Lsamples_Sealed$package$$anon$6$$anon$17$$anon$19 };
$p = $c_Lsamples_Sealed$package$$anon$6$$anon$17$$anon$19.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Lsamples_Sealed$package$$anon$6$$anon$17$$anon$19;
/** @constructor */
function $h_Lsamples_Sealed$package$$anon$6$$anon$17$$anon$19() {
}
export { $h_Lsamples_Sealed$package$$anon$6$$anon$17$$anon$19 as $h_Lsamples_Sealed$package$$anon$6$$anon$17$$anon$19 };
$h_Lsamples_Sealed$package$$anon$6$$anon$17$$anon$19.prototype = $p;
$p.b = (function() {
  return "<function0>";
});
$p.v = (function() {
  var v = this.LU.h();
  return (((typeof v) === "string") ? new $j_java$002elang$002e$002dObject.$c_s_Some(v) : $j_java$002elang$002e$002dObject.$m_s_None$());
});
$p.h = (function() {
  return this.v();
});
var $d_Lsamples_Sealed$package$$anon$6$$anon$17$$anon$19 = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lsamples_Sealed$package$$anon$6$$anon$17$$anon$19, "samples.Sealed$package$$anon$6$$anon$17$$anon$19", ({
  ql: 1,
  d: 1,
  a: 1,
  f: 1
}));
export { $d_Lsamples_Sealed$package$$anon$6$$anon$17$$anon$19 as $d_Lsamples_Sealed$package$$anon$6$$anon$17$$anon$19 };
